import React from "react";
import { ArrowRight, PlayCircle } from "lucide-react";
import { HERO } from "../../mock/mock";
import { trackEvent } from "../../lib/analytics";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-10 md:pt-16 pb-14 md:pb-24">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Text column */}
          <div className="lg:col-span-7 reveal">
            <p className="eyebrow text-base md:text-lg">{HERO.eyebrow}</p>
            <p className="eyebrow text-sm md:text-[15px] tracking-[0.14em] mt-1 mb-5">{HERO.eyebrowSub}</p>

            <h1 className="font-serif-display text-[2.4rem] sm:text-5xl md:text-6xl lg:text-[4.25rem] leading-[1.05] text-[#1a1a1a]">
              <span className="block">{HERO.headlinePre}</span>{" "}
              <span className="block">{HERO.headlineMain}</span>{" "}
              <span className="block italic text-[#7a1e2f]">{HERO.headlineItalic}</span>
            </h1>

            <p className="mt-6 md:mt-8 text-[15px] md:text-lg text-[#1a1a1a]/75 max-w-2xl leading-relaxed">
              {HERO.sub}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href="#apply" onClick={() => trackEvent("cta_click", { label: "hero_apply_now", location: "hero" })} className="btn-primary rounded-full px-6 py-3.5 text-sm tracking-wider uppercase inline-flex items-center gap-2">
                {HERO.primaryCta} <ArrowRight size={16} />
              </a>
              <a href="#program" onClick={() => trackEvent("cta_click", { label: "hero_see_how", location: "hero" })} className="btn-outline-dark rounded-full px-6 py-3.5 text-sm tracking-wider uppercase inline-flex items-center gap-2">
                <PlayCircle size={16} /> {HERO.secondaryCta}
              </a>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-2xl">
              {HERO.facts.map((f) => (
                <div key={f.k} className="border-t border-[#d9cdb8] pt-3">
                  <div className="text-[11px] tracking-[0.18em] uppercase text-[#1a1a1a]/60">{f.k}</div>
                  <div className="mt-1 font-serif-display text-xl md:text-2xl text-[#1a1a1a]">{f.v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image column */}
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full bg-[#e4d8c9] -z-0 hidden md:block" />
              <div className="absolute -bottom-8 -right-6 w-56 h-56 rounded-full bg-[#7a1e2f]/10 -z-0 hidden md:block" />
              <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_-30px_rgba(0,0,0,0.35)]">
                <img
                  src={HERO.image}
                  alt="Michelle Fragias — keynote speaker and communication coach"
                  className="w-full h-[440px] md:h-[560px] object-cover object-top"
                />
                <div className="absolute bottom-4 left-4 right-4 bg-white/85 backdrop-blur rounded-xl px-4 py-3 flex items-center gap-3">
                  <div className="h-9 w-9 rounded-full bg-[#7a1e2f] text-white grid place-items-center text-xs font-semibold">MF</div>
                  <div className="text-[13px] leading-tight">
                    <div className="font-medium text-[#1a1a1a]">Led by Michelle Fragias</div>
                    <div className="text-[#1a1a1a]/60">Speaker · Communication Coach · Truth Activator</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
